import moment from 'moment-timezone';

const modes = {
  expired: (days: number | undefined) => days <= 0,
  expiring: (days: number | undefined) => days <= 7,
  valid: (days: number | undefined) => days >= 8,
};

export const ExpirationModes = {
  modes,
  compare(
    date: string | number | string[],
    mode: typeof modes.expired,
    timezone: string,
    compare = Date.now(),
  ) {
    const compareMeasure = 'day';
    const [sourceDate, targetDate] = [
      moment(compare).tz(timezone).startOf(compareMeasure),
      moment(date).tz(timezone).startOf(compareMeasure),
    ];
    const difference = targetDate.diff(sourceDate, compareMeasure);
    return date && mode(difference);
  },
};
